import React from 'react'
import { Controller } from 'react-hook-form'

import { RadioGroup as ChakraRadioGroup, Radio as ChakraRadio, Stack, HStack } from '@chakra-ui/react'
import FieldWrapper from '../FieldWrapper/FieldWrapper'

const Radio = ({ name, options = [], disabled, isRow = false, defaultValue, ...rest }) => {
    return (
        <Controller
            name={name}
            defaultValue={defaultValue}
            render={({ field: { value, onChange, onBlur, ref }, fieldState: { error } }) => {
                const Component = isRow ? HStack : Stack
                const spacing = isRow ? 4 : 1
                const pl = isRow ? 0 : 6

                // Determine current value for RadioGroup (must be string)
                let currentValue = undefined
                if (value !== undefined && value !== null && value !== '') {
                    currentValue = String(value)
                } else if (defaultValue !== undefined && defaultValue !== null && defaultValue !== '') {
                    currentValue = String(defaultValue)
                }

                return (
                    <FieldWrapper name={name} error={error} {...rest}>
                        <ChakraRadioGroup
                            colorScheme="blue"
                            value={currentValue}
                            onChange={(val) => {
                                // Convert string back to original type based on option values
                                const selectedOption = options.find((opt) => String(opt.value) === val)
                                if (selectedOption) {
                                    if (
                                        selectedOption.value === '' ||
                                        selectedOption.value === undefined ||
                                        selectedOption.value === null
                                    ) {
                                        onChange(undefined)
                                    } else {
                                        onChange(selectedOption.value)
                                    }
                                } else {
                                    // Fallback: try to convert string to boolean if needed
                                    if (val === 'true') {
                                        onChange(true)
                                    } else if (val === 'false') {
                                        onChange(false)
                                    } else {
                                        onChange(val)
                                    }
                                }
                            }}
                            onBlur={onBlur}
                            isDisabled={disabled}
                            isInvalid={error !== undefined}
                        >
                            <Component spacing={spacing} pl={pl} mt={1}>
                                {options.map((option, index) => (
                                    <ChakraRadio key={`radio_${name}_${index}`} value={String(option.value)}>
                                        {option.label}
                                    </ChakraRadio>
                                ))}
                            </Component>
                        </ChakraRadioGroup>
                    </FieldWrapper>
                )
            }}
        />
    )
}

export default Radio

